import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DeblurIcon(props: IconProps) {
    return <Icon {...props} iconKey={"deblur"}/>
}
